export const MARKETPLACE_DEVELOPER_ROUTES = {
  ROOT: '/developer',
  CUSTOM_APP: '/developer/custom-app',
  BROWSE: '/developer',
} as const;
